import { createContext, useContext } from 'react';
import type { RegularAvailabilitySlotType } from '@discover-data/stores/restaurant/model/types';
import { type NonEmptyAvailabilityOptions } from '@discover-data/stores/restaurant/gql/getters/allAvailabilitySearch';

export type RegularAvailabilitySlotWithNonEmptyAvailabilityOptions = Omit<
  RegularAvailabilitySlotType,
  'options' | 'time'
> & {
  time: string;
  options: NonEmptyAvailabilityOptions;
};

export type AvailabilityOptionsDialogContextType = {
  selectedSlot: RegularAvailabilitySlotWithNonEmptyAvailabilityOptions | null;
  selectedRestaurantId: number | null;
  setSelected:
    | (({
        selectedSlot,
        selectedRestaurantId,
      }: {
        selectedSlot: RegularAvailabilitySlotWithNonEmptyAvailabilityOptions | null;
        selectedRestaurantId: number | null;
      }) => void)
    | null;
};

const AvailabilityOptionsDialogContext = createContext<AvailabilityOptionsDialogContextType>({
  selectedSlot: null,
  selectedRestaurantId: null,
  setSelected: null,
});

export default AvailabilityOptionsDialogContext;

export function useAvailabilityOptionsDialogContext() {
  const { selectedSlot, selectedRestaurantId, setSelected } = useContext(
    AvailabilityOptionsDialogContext
  );

  return { selectedSlot, selectedRestaurantId, setSelected };
}
